import "./App.css";
import "./output.css"
import Sidebar from "./components/sidebar/Sidebar";
import Topbar from "./components/topbar/Topbar";
import Content from "./components/content/Content";
import React from "react";
import { net } from "./database";
import { PrimaryColorProvider } from "./components/content/components/PrimaryColorContext";
import Login from "./Login";
import MobileHome from "./components/mobile/MobileHome";
import Score from "./components/content/score/Score";
import updatePrototypes from "./updatePrototypes";

export var socket = () => null

updatePrototypes()



export var apiKey = localStorage.getItem("apiKey") || undefined;
export function deleteApiKey() {
  apiKey = undefined;
}
function setApiKey(newKey) {
  apiKey = newKey
}

/* const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js", {
        scope: "/",
      });
      if (registration.installing) {
        console.log("Service worker installing");
      } else if (registration.waiting) {
        console.log("Service worker installed");
      } else if (registration.active) {
        console.log("Service worker active");
      }
    } catch (error) {
      console.error(`Registration failed with ${error}`);
    }
  }
}; */

// …

//registerServiceWorker();

export default function App({user,setUser,center,setCenter,setLanguage,language,staffAll,l}) {
  if (user === undefined)
    return (
      <PrimaryColorProvider>
        <Login apiKey={apiKey} setUser={setUser} setApiKey={setApiKey} />
      </PrimaryColorProvider>
    );

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  )
    return (
      <MobileHome language={language} l={l} user={user} />
    );

  return (
    <PrimaryColorProvider>
      <div style={{ display: "flex", width: "100%" }}>
        <Sidebar />
        <div style={{ flexGrow: 1 }}>
          {user.roles.includes("Owner") && <Score />}
          <Topbar
            language={language}
            setLanguage={setLanguage}
            net={net}
            center={center}
            user={user}
            setUser={setUser}
            l={l}
          />
          <Content
            net={net}
            user={user}
            setUser={setUser}
            language={language}
            l={l}
            center={center}
            setCenter={setCenter}
            className="content"
          />
        </div>
      </div>
    </PrimaryColorProvider>
  );
}